<ng-container *ngIf="operator">
  <ng-container *ngIf="!lockIncludeExclude">
    <span>
      <button class="link p-0"
              role="switch"
              type="button"
              *ngIf="isInclude"
              aria-label="Click to change to exclude"
              (click)="toggleIncludes(true)">Include</button>
      <button class="link p-0"
              *ngIf="!isInclude"
              type="button"
              role="switch"
              aria-label="Click to change to include"
              (click)="toggleIncludes(false)">Exclude</button>
      {{targetTypeText}} with
    </span>
  </ng-container>

  <span *ngIf="lockIncludeExclude">
    {{isInclude ? 'Include' : 'Exclude'}} {{targetTypeText}} with
  </span>

  <span *ngIf="!hideAnyOrAll">
    <button *ngIf="isAny"
            class="link p-0"
            type="button"
            role="switch"
            aria-label="Click to change to all"
            (click)="toggleAny(false)">any</button>
    <button *ngIf="!isAny"
            class="link p-0"
            type="button"
            role="switch"
            aria-label="Click to change to any"
            (click)="toggleAny(true)">all</button>
    of
  </span>
  <span>
    these {{forTypeText}}
  </span>
</ng-container>
